/**
* this file contains the array for the topbar & left menu component
*
* Created by Tom on 28/5/17
*/

import config from '../../config'

const menuItems = [
    {
        menuIcon: null,
        menuText: 'ABOUT',
        isExternal: true,
        openInNewTab: true,
        route: config.endpoints.websiteAboutURL
    },
    {
        menuIcon: null,
        menuText: 'FAQS',
        isExternal: true,
        openInNewTab: true,
        route: config.endpoints.websiteFAQsURL
    },
    {
        menuIcon: null,
        menuText: 'HOW IT WORKS',
        isExternal: true,
        openInNewTab: true,
        route: config.endpoints.websiteHowItWorksURL
    },
    {
        menuIcon: null,
        menuText: 'MY ACCOUNT',
        isExternal: false,
        route: '/account'
    },
    {
        menuIcon: null,
        menuText: 'SIGN OUT',
        isExternal: true,
        route: config.endpoints.websiteSignOutURL
    },
    {
        menuIcon: null,
        menuText: 'DASHBOARD',
        isExternal: false,
        openInNewTab: false,
        route: '/'
    },
]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/TopBar/menuItems.js